import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router';
import { observer } from 'mobx-react-lite';
import { ChevronRightIcon } from '@radix-ui/react-icons';

import { Header } from './project.page';
import { Location } from '../../app/entities/location';
import { FolderView } from '../../features/assets/components/folder-view';
import { uiStore } from '../../core/stores/ui-store';

import styles from './project-location.route.module.scss';
export const ProjectLocationRoute: React.FC = observer(() => {
  const { locationId } = useParams() as { locationId: string };

  const location = Location.getOne(locationId)!;

  useEffect(() => {
    uiStore.currentLocation = 'project.locations';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  return (
    <>
      <Header>
        <div className={styles['crumb']}>
          <Link className={styles['parent']} to="../">
            Locations
          </Link>
          <ChevronRightIcon />
          {location.name}
        </div>
      </Header>

      <FolderView folderId={location.assetsFolderId || ''} isRoot />
    </>
  );
});
